import { render, staticRenderFns } from "./ProductCategoryFilter.vue?vue&type=template&id=650c010c"
import script from "./ProductCategoryFilter.vue?vue&type=script&lang=js"
export * from "./ProductCategoryFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FilterIcon: require('/vercel/path0/components/icons/FilterIcon.vue').default,ProductCategoryFilterOpen: require('/vercel/path0/components/shared/product-category/ProductCategoryFilterOpen.vue').default})
